import {
  FilterOption,
  FilterOptionDate,
  FilterOptionRange,
  FilterOptionSelect,
  FilterTypes,
} from 'features/filters/types'

/**
 * Return a copy of `filters` with panel-narrowed counts stripped.
 *
 * Used as the names-only fallback for the per-panel V2 hook
 * (`usePanelFilterOptions`). While a V2 fetch is in flight and no prior
 * V2 result is cached, the UI renders this stripped copy so it never
 * shows stale V1 counts. PROD-2077.
 *
 * Stripped fields:
 * - select values: `n_posts`
 * - date / window options: `cur_min`, `cur_max`, `Null`
 *
 * Schema fields (`field`, `alias`, `filter_type`, `min`, `max`, etc.)
 * are preserved.
 */
export const stripFilterCounts = (filters: FilterOption[]): FilterOption[] =>
  filters.map((option) => {
    if (option.filter_type === FilterTypes.SELECT) {
      return {
        ...option,
        values: option.values.map(({ n_posts: _ignored, ...rest }) => rest),
      } satisfies FilterOptionSelect
    }
    const { cur_min: _curMin, cur_max: _curMax, Null: _null, ...rest } = option
    return rest as FilterOptionDate | FilterOptionRange
  })
